// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagados_container__8v5db {
  animation: Pagados_init__E2BYC 0.5s;
  width: 100%;
  height: 95%;
  margin-top: 20px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Pagados_container__8v5db .Pagados_headerLogo__Qrad- {
  margin-left: 30px;
  width: 15rem;
  max-height: 20rem;
  object-fit: scale-down;
}

/*---------------- filtros ------------------- */

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_filters__6xwpZ {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_filters__6xwpZ .Pagados_datePickers__2EtU6 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_filters__6xwpZ .Pagados_datePickers__2EtU6 p {
  width: 100%;
  font-size: 1.2em;
  margin: 0;
  margin-left: 25px;
  margin-bottom: 10px;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_filters__6xwpZ .Pagados_datePickers__2EtU6 .Pagados_date__nbLdH {
  scale: 0.8;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_filters__6xwpZ .Pagados_switches__Ib76e {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_filters__6xwpZ .Pagados_switches__Ib76e .Pagados_switch__GJZtK {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_filters__6xwpZ .Pagados_switches__Ib76e .Pagados_switch__GJZtK p {
  text-align: center;
  margin: 0;
  font-size: 0.8em;
  margin-bottom: 5px;
}

/*----------------------------------------------------------- */

/*---------------- card total prizes excel------------------- */

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_cardExcel__0Wwtk {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_cardExcel__0Wwtk .Pagados_data__Si\\+-Y {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  min-width: 80%;
  height: 90%;
  box-shadow: 5px 5px 15px -3px rgba(0, 0, 0, 0.298);
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_cardExcel__0Wwtk .Pagados_data__Si\\+-Y .Pagados_totalPrizes__aA5BF {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_cardExcel__0Wwtk .Pagados_data__Si\\+-Y .Pagados_totalPrizes__aA5BF p {
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-top: 10px;
  margin-bottom: 10px;
}

.Pagados_container__8v5db .Pagados_cardExcel__0Wwtk .Pagados_data__Si\\+-Y .Pagados_totalPrizes__aA5BF .Pagados_infoPrizes__i1D38 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 10px;
}

.Pagados_container__8v5db
  .Pagados_filtersContainer__nrpWt
  .Pagados_cardExcel__0Wwtk
  .Pagados_data__Si\\+-Y
  .Pagados_totalPrizes__aA5BF
  .Pagados_infoPrizes__i1D38
  .Pagados_chipInfoPrizes__30VHG {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  height: 30px;
  border-radius: 10px;
  padding-left: 5px;
  font-size: 0.3rem;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  box-shadow: 3px 3px 15px -3px rgba(0, 0, 0, 0.101);
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_cardExcel__0Wwtk .Pagados_data__Si\\+-Y .Pagados_excelBtn__fcuzZ {
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_cardExcel__0Wwtk .Pagados_data__Si\\+-Y .Pagados_excelBtn__fcuzZ p {
  font-size: 1rem;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  text-align: center;
  margin: 0;
  margin-inline: 8px;
}

.Pagados_container__8v5db .Pagados_filtersContainer__nrpWt .Pagados_cardExcel__0Wwtk .Pagados_data__Si\\+-Y .Pagados_excelBtn__fcuzZ:hover {
  transition: 0.3s;
  scale: 1.02;
  cursor: pointer;
  filter: saturate(2);
}

/*--------------------------------------------------------------- */

/*------------------------tabla de juegos------------------------ */

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
  height: 85%;
  font-family: Roboto, sans-serif;
  font-weight: 400;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm {
  transition: 0.3s;
  margin-bottom: 10px;
  border-radius: 10px;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_gameName__1xA9Q {
  display: flex;
  justify-content: space-between;
  width: 98%;
  align-items: center;
  font-size: 1.1rem;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_gameName__1xA9Q p {
  margin: 0;
  width: 33.333%;
  text-align: end;
  display: flex;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_gameName__1xA9Q span {
  margin: 0;
  font-size: 1.1rem;
  margin-right: 10px;
  font-weight: 400;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_gameName__1xA9Q .Pagados_p1__KmriQ {
  margin: 0;
  text-align: start !important;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm:hover {
  transition: 0.3s;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_accordionDetails__xb-VF {
  background-color: white;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_accordionDetails__xb-VF .Pagados_tableContainer__WDnNT {
  border-radius: 10px;
  max-height: 500px;
  overflow-y: scroll;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_accordionDetails__xb-VF .Pagados_icon__rOqUr {
  transition: 0.3s;
}

.Pagados_container__8v5db .Pagados_gamesTable__8gvQb .Pagados_accordion__zSvcm .Pagados_accordionDetails__xb-VF .Pagados_icon__rOqUr:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(1.5);
}

@keyframes Pagados_init__E2BYC {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* 
@media screen and (min-width: 1300px) and (min-height: 650px) {
    .container{
        font-size: 16px;
    }
}

@media screen and (min-width: 1100px) and (min-height: 500px) {
    .container{
        font-size: 12px;
    }
} */
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Premios/Tabs/Pagados/Pagados.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAoB;EACpB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+DAA+D;;AAE/D,+DAA+D;;AAE/D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,mEAAmE;;AAEnE,mEAAmE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;;;;;;;;;;GAWG","sourcesContent":[".container {\n  animation: init 0.5s;\n  width: 100%;\n  height: 95%;\n  margin-top: 20px;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.container .filtersContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .headerLogo {\n  margin-left: 30px;\n  width: 15rem;\n  max-height: 20rem;\n  object-fit: scale-down;\n}\n\n/*---------------- filtros ------------------- */\n\n.container .filtersContainer .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.container .filtersContainer .filters .datePickers {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.container .filtersContainer .filters .datePickers p {\n  width: 100%;\n  font-size: 1.2em;\n  margin: 0;\n  margin-left: 25px;\n  margin-bottom: 10px;\n}\n\n.container .filtersContainer .filters .datePickers .date {\n  scale: 0.8;\n}\n\n.container .filtersContainer .filters .switches {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.container .filtersContainer .filters .switches .switch {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n}\n\n.container .filtersContainer .filters .switches .switch p {\n  text-align: center;\n  margin: 0;\n  font-size: 0.8em;\n  margin-bottom: 5px;\n}\n\n/*----------------------------------------------------------- */\n\n/*---------------- card total prizes excel------------------- */\n\n.container .filtersContainer .cardExcel {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.container .filtersContainer .cardExcel .data {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  min-width: 80%;\n  height: 90%;\n  box-shadow: 5px 5px 15px -3px rgba(0, 0, 0, 0.298);\n}\n\n.container .filtersContainer .cardExcel .data .totalPrizes {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.container .filtersContainer .cardExcel .data .totalPrizes p {\n  width: 100%;\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.container .cardExcel .data .totalPrizes .infoPrizes {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-left: 10px;\n}\n\n.container\n  .filtersContainer\n  .cardExcel\n  .data\n  .totalPrizes\n  .infoPrizes\n  .chipInfoPrizes {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  height: 30px;\n  border-radius: 10px;\n  padding-left: 5px;\n  font-size: 0.3rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n  box-shadow: 3px 3px 15px -3px rgba(0, 0, 0, 0.101);\n}\n\n.container .filtersContainer .cardExcel .data .excelBtn {\n  transition: 0.3s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.container .filtersContainer .cardExcel .data .excelBtn p {\n  font-size: 1rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n  text-align: center;\n  margin: 0;\n  margin-inline: 8px;\n}\n\n.container .filtersContainer .cardExcel .data .excelBtn:hover {\n  transition: 0.3s;\n  scale: 1.02;\n  cursor: pointer;\n  filter: saturate(2);\n}\n\n/*--------------------------------------------------------------- */\n\n/*------------------------tabla de juegos------------------------ */\n\n.container .gamesTable {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  height: 85%;\n  font-family: Roboto, sans-serif;\n  font-weight: 400;\n}\n\n.container .gamesTable .accordion {\n  transition: 0.3s;\n  margin-bottom: 10px;\n  border-radius: 10px;\n}\n\n.container .gamesTable .accordion .gameName {\n  display: flex;\n  justify-content: space-between;\n  width: 98%;\n  align-items: center;\n  font-size: 1.1rem;\n}\n\n.container .gamesTable .accordion .gameName p {\n  margin: 0;\n  width: 33.333%;\n  text-align: end;\n  display: flex;\n}\n\n.container .gamesTable .accordion .gameName span {\n  margin: 0;\n  font-size: 1.1rem;\n  margin-right: 10px;\n  font-weight: 400;\n}\n\n.container .gamesTable .accordion .gameName .p1 {\n  margin: 0;\n  text-align: start !important;\n}\n\n.container .gamesTable .accordion:hover {\n  transition: 0.3s;\n}\n\n.container .gamesTable .accordion .accordionDetails {\n  background-color: white;\n}\n\n.container .gamesTable .accordion .accordionDetails .tableContainer {\n  border-radius: 10px;\n  max-height: 500px;\n  overflow-y: scroll;\n}\n\n.container .gamesTable .accordion .accordionDetails .icon {\n  transition: 0.3s;\n}\n\n.container .gamesTable .accordion .accordionDetails .icon:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(1.5);\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/* \n@media screen and (min-width: 1300px) and (min-height: 650px) {\n    .container{\n        font-size: 16px;\n    }\n}\n\n@media screen and (min-width: 1100px) and (min-height: 500px) {\n    .container{\n        font-size: 12px;\n    }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Pagados_container__8v5db`,
	"init": `Pagados_init__E2BYC`,
	"filtersContainer": `Pagados_filtersContainer__nrpWt`,
	"headerLogo": `Pagados_headerLogo__Qrad-`,
	"filters": `Pagados_filters__6xwpZ`,
	"datePickers": `Pagados_datePickers__2EtU6`,
	"date": `Pagados_date__nbLdH`,
	"switches": `Pagados_switches__Ib76e`,
	"switch": `Pagados_switch__GJZtK`,
	"cardExcel": `Pagados_cardExcel__0Wwtk`,
	"data": `Pagados_data__Si+-Y`,
	"totalPrizes": `Pagados_totalPrizes__aA5BF`,
	"infoPrizes": `Pagados_infoPrizes__i1D38`,
	"chipInfoPrizes": `Pagados_chipInfoPrizes__30VHG`,
	"excelBtn": `Pagados_excelBtn__fcuzZ`,
	"gamesTable": `Pagados_gamesTable__8gvQb`,
	"accordion": `Pagados_accordion__zSvcm`,
	"gameName": `Pagados_gameName__1xA9Q`,
	"p1": `Pagados_p1__KmriQ`,
	"accordionDetails": `Pagados_accordionDetails__xb-VF`,
	"tableContainer": `Pagados_tableContainer__WDnNT`,
	"icon": `Pagados_icon__rOqUr`
};
export default ___CSS_LOADER_EXPORT___;
